(function () {
  'use strict';

  var mnav = document.getElementById('rm-mnav');
  if (!mnav) return;

  /* Verplaats de drawer naar <body>, weg uit de header-stapelcontext.
     Anders zit position:fixed/z-index "gevangen" in de header en liggen
     app-widgets (Shop with AI, WhatsApp) en de aankondigingsbalk eroverheen. */
  if (mnav.parentNode !== document.body) document.body.appendChild(mnav);

  var mq = window.matchMedia('(max-width: 989px)');
  var root = mnav.querySelector('[data-mnav-panel="root"]');

  function lock(on) {
    document.documentElement.classList.toggle('rm-mnav-lock', on);
  }
  function resetPanels() {
    mnav.querySelectorAll('.rm-mnav__panel').forEach(function (p) {
      if (p !== root) p.classList.remove('is-active');
    });
    if (root) root.classList.remove('is-behind');
  }
  function open() {
    resetPanels();
    mnav.classList.add('is-open');
    mnav.setAttribute('aria-hidden', 'false');
    lock(true);
  }
  function close() {
    mnav.classList.remove('is-open');
    mnav.setAttribute('aria-hidden', 'true');
    lock(false);
    setTimeout(resetPanels, 340);
  }
  function to(name) {
    var p = mnav.querySelector('[data-mnav-panel="' + name + '"]');
    if (!p) return;
    p.classList.add('is-active');
    if (root) root.classList.add('is-behind');
    p.scrollTop = 0;
  }

  mnav.addEventListener('click', function (e) {
    var t = e.target.closest('[data-mnav-to],[data-mnav-back],[data-mnav-close]');
    if (!t) return;
    if (t.hasAttribute('data-mnav-close')) { e.preventDefault(); close(); return; }
    if (t.hasAttribute('data-mnav-back')) { e.preventDefault(); resetPanels(); return; }
    var name = t.getAttribute('data-mnav-to');
    if (name) { e.preventDefault(); to(name); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && mnav.classList.contains('is-open')) close();
  });

  /* Haak in op de bestaande hamburger (Dawn-summary): open onze drawer i.p.v. de Dawn-drawer.
     Capture-fase + stopImmediatePropagation zodat Dawn's eigen handler niet ook afgaat. */
  var summary = document.querySelector('#Details-menu-drawer-container > summary');
  if (summary) {
    summary.addEventListener('click', function (e) {
      if (!mq.matches) return; // alleen mobiel/tablet
      e.preventDefault();
      e.stopImmediatePropagation();
      var det = summary.closest('details');
      if (det) det.removeAttribute('open');
      open();
    }, true);
  }
})();
